import { SIGN_IN_PATH } from '@/shared/config/routes'
import { clearAccessToken } from '@/shared/lib/auth/token'

export const redirectToSignIn = (): void => {
  clearAccessToken()
  if (window.location.pathname === SIGN_IN_PATH) return

  const params = new URLSearchParams({
    redirectTo: `${window.location.pathname}${window.location.search}${window.location.hash}`,
  })
  window.location.href = `${SIGN_IN_PATH}?${params.toString()}`
}
